import script from "./report2Zyltrz.vue?vue&type=script&setup=true&lang=js"
export * from "./report2Zyltrz.vue?vue&type=script&setup=true&lang=js"

import "./report2Zyltrz.vue?vue&type=style&index=0&id=99508f96&lang=less"

const __exports__ = script;

export default __exports__